module.exports = __webpack_public_path__ + "img/academy_bubble_keynotes.033f1049.png";